export default __webpack_public_path__ + "static/media/ic_subscribers.28291fe1.svg";